<template>
  <div class="module2 pageContainer">
    <div class="quickArea">
      <el-button
        plain round
        @click.stop.prevent="onQuickSearch('all')">
        全部商品(<span class="num">{{quickData.all}}</span>)
      </el-button>
      <el-button
        plain round
        @click.stop.prevent="onQuickSearch('ysj', 1)">
        已上架(<span class="num">{{quickData.ysj}}</span>)
      </el-button>
    </div>
    <!--搜索区域-->
    <div class="searchArea u-border">
      <el-form :model="form" label-width="100px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="xxx编码:">
              <el-input
                v-model.trim="form.code"
                placeholder="xxx编码"
                @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="xxx名称:">
              <el-input
                v-model.trim="form.name"
                placeholder="xxx名称"
                @keyup.enter.native="onSearch">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--搜索展开项-->
        <el-row v-show="searchIsOpen">
          <el-col :span="6">
            <el-form-item label="xxx编码:">
              <el-input
                v-model.trim="form.code"
                placeholder="xxx编码"
                @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="u-textRight">
          <el-form-item>
            <el-button type="primary" @click.stop.prevent="onSearch">搜索</el-button>
            <el-button @click.stop.prevent="onReset">重置</el-button>
            <el-button
              type="text"
              @click.stop.prevent="searchIsOpen = true"
              v-show="!searchIsOpen">
              展开<i class="el-icon-arrow-down"></i>
            </el-button>
            <el-button
              type="text"
              @click.stop.prevent="searchIsOpen = false"
              v-show="searchIsOpen">
              折叠<i class="el-icon-arrow-up"></i>
            </el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <!--列表区域-->
    <div class="resultArea u-border">
      <div class="optionArea u-cf">
        <div class="u-fl">
          <el-button type="primary" icon="el-icon-plus" @click.stop="onAdd">新增</el-button>
          <el-button type="danger" icon="el-icon-delete" @click.stop="onDeleteAll">批量删除</el-button>
        </div>
        <div class="u-fr">
        </div>
      </div>
      <div class="tableList">
        <el-table
          empty-text="抱歉，暂无相关数据"
          style="width: 100%"
          v-loading="tableLoad"
          :data="tableData"
          @selection-change="onTableSelectionChange"
          @sort-change="onTableSortChange"
          @cell-click="onCellClick">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号" width="55"></el-table-column>
          <el-table-column prop="code" label="xxx编码"></el-table-column>
          <el-table-column prop="name" label="xxx名称" sortable></el-table-column>
          <el-table-column
            label="操作"
            width="140">
            <template slot-scope="scope">
              <el-button
                type="text" size="small"
                @click.stop="onDelete(scope.row)">
                删除
              </el-button>
              <el-button
                type="text" size="small"
                @click.stop="onEdit(scope.row)">
                修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <PaginationCom
        :pageData="pageData"
        @size-change="onPageSizeChange"
        @current-change="onCurrentPageChange">
      </PaginationCom>
    </div>
    
    <!--操作确认-->
    <ConfirmDialog ref="ConfirmDialog" :fatherData="confirmData" @onConfirmSubmit="onConfirmSubmit"></ConfirmDialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { PAGINATION } from '@/helpers/baseData';
  import { pushToWhere, joinSql } from '@/utils/searchParams';
  // 接口
  import { test } from '@/api/common';
  // 导入子组件
  import PaginationCom from '@/views/_common/PaginationCom';
  import ConfirmDialogCom from '@/views/_common/ConfirmDialogCom';
  
  // 初始化表单
  function getInitForm () {
    return {
      code: '',
      name: ''
    };
  }
  
  export default {
    name: 'module2',
    inject: ['myMessage'],
    components: {
      'PaginationCom': PaginationCom,
      'ConfirmDialog': ConfirmDialogCom
    },
    computed: {
      ...mapGetters([
        'screenLoading'
      ])
    },
    data () {
      return {
        pageData: {
          total: 0,
          pageSize: PAGINATION.pageSize,
          currentPage: 1
        },
        searchIsOpen: false, // 是否展开搜索项
        tableLoad: false,
        tableData: [],
        tableOrderBy: [],
        selectionData: [],
        quickData: {
          all: ''
        },
        confirmData: {},
        form: getInitForm()
      };
    },
    methods: {
      onQuickSearch (key, val) {
        if (key === 'all') {
          this.onReset();
          return;
        }
        
        this.form = getInitForm();
        this.form[key] = val;
        this.onSearch();
      },
      
      requestQuickData () {
        const requestData = {};
        test(requestData)
          .then(res => {
            this.quickData.all = res.all;
          })
          .catch(() => {
            this.myMessage.megError('获取条数失败');
          });
      },
      
      // 请求列表页
      requestList () {
        this.tableLoad = true;
        test(this.handleFormData())
          .then(res => {
            this.handleListData(res);
          })
          .catch(() => {
            this.myMessage.megError('获取列表失败');
          })
          .finally(() => {
            this.tableLoad = false;
          });
      },
      
      // 处理请求数据
      handleFormData () {
        const requestData = {
          page: this.pageData.currentPage,
          limit: this.pageData.pageSize,
          orderBy: this.tableOrderBy,
          where: []
        };
        
        pushToWhere(requestData.where, joinSql('code', 'like', this.form.code, ''));
        pushToWhere(requestData.where, joinSql('name', 'like', this.form.name, ''));
        return requestData;
      },
      
      // 处理结果数据
      handleListData (res) {
        this.pageData.total = res.count;
        this.tableData = res.datalist;
      },
      
      requestDeleteAll (cancleFun) {
        const requestData = {
          ids: []
        };
        
        this.confirmData.rows.forEach(item => {
          requestData.ids.push(item.id);
        });
        
        test(requestData)
          .then(res => {
            this.confirmData = {};
            this.myMessage.megSuc('删除成功');
            cancleFun();
            this.onSearch();
          })
          .catch(() => {
            this.myMessage.megError('删除失败,请重试');
          });
      },
      
      // 删除提交
      onConfirmSubmit (cancleFun) {
        this.requestDeleteAll(cancleFun);
      },
      
      onDeleteAll () {
        if (this.selectionData.length < 1) {
          this.myMessage.megError('请选择数据');
          return;
        }
        
        this.confirmData = {
          tips: '选中的' + this.selectionData.length + '条数据',
          rows: this.selectionData
        };
        
        this.$refs.ConfirmDialog.visible = true;
      },
      
      onDelete (row) {
        this.confirmData = {
          tips: 'xxx编号为：' + row.code,
          rows: [row]
        };
        
        this.$refs.ConfirmDialog.visible = true;
      },
      
      onAdd () {
        this.$router.push({ path: `${this.$route.path}/new` });
      },
      
      onEdit (row) {
        this.cacheSearchForm();
        this.$router.push({ path: this.$route.path + '/new', query: { id: row.id } });
      },
      
      onCellClick (row) {
        this.cacheSearchForm();
        this.$router.push({
          path: `${this.$route.path}/${row.id}`
        });
      },
      
      onTableSortChange (column) {
        this.selectionData = [];
        this.tableData = [];
        const myOrder = column.order === 'ascending' ? 'ASC' : 'DESC';
        this.tableOrderBy = [column.prop, myOrder];
        this.pageData.total = 0;
        this.pageData.currentPage = 1;
        this.requestList();
      },
      
      onTableSelectionChange (rows) {
        this.selectionData = rows;
      },
      
      onPageSizeChange (size) {
        this.pageData.pageSize = size;
        this.pageData.currentPage = 1;
        this.selectionData = [];
        this.requestList();
      },
      
      onCurrentPageChange (page) {
        this.pageData.currentPage = page;
        this.selectionData = [];
        this.requestList();
      },
      
      onSearch () {
        this.pageData.total = 0;
        this.pageData.currentPage = 1;
        this.selectionData = [];
        this.tableOrderBy = [];
        // this.tableData = [];
        this.requestList();
      },
      
      onReset () {
        this.form = getInitForm();
        this.onSearch();
      },
      
      cacheSearchForm () {
        sessionStorage.setItem(
          this.$route.path,
          JSON.stringify({
            pageSize: this.pageData.pageSize,
            currentPage: this.pageData.currentPage,
            form: this.form
          }));
      }
    },
    created () {
      const cache = JSON.parse(sessionStorage.getItem(this.$route.path));
      if (cache) {
        this.pageData.pageSize = cache.pageSize;
        this.pageData.currentPage = cache.currentPage;
        this.form = cache.form;
        sessionStorage.removeItem(this.$route.path);
      }

      this.requestQuickData();
      this.requestList();
    }
  };
</script>

<style lang="scss">
  .module2 {
  }
</style>
